import styled from "styled-components";
import {useEffect, useState} from "react";
import {Job, RepoInfo, Skeleton} from "../../api/types";
import {agent} from "../../api/agent";
import SearchInput from "../Search/SearchInput";
import {useNavigate} from "react-router-dom";
import SyncedList from "../SyncedList";
import Loading from "../Loading";
import Status from "../Status";


const Container = styled.div`

    .content {
        display: grid;
        gap: 1rem;
        justify-content: center;
        margin: 1rem 0;
        grid-template-columns: 40%;
    }

    .job-item {
        background-color: var(--content-box-bg);
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        padding: 2rem;
        display: grid;
        grid-template-columns: auto auto;
        cursor: pointer;
    }

    .job-item:hover {
        background-color: var(--content-box-hover);
    }

    .job-item h1 {
        margin: 0;
    }

`;


export default function JobList() {
    const [jobs, setJobs] = useState<RepoInfo[]>([]);
    const [filteredJobs, setFilteredJobs] = useState<RepoInfo[]>([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const syncedList = new SyncedList<RepoInfo>();
        const id = agent.subscribe('/repo', (value: RepoInfo[]) => {
            syncedList.processData(value);

            setJobs(syncedList.getList().sort((a, b) => new Date(b.lastSkeleton?.date ?? new Date(0)).getTime() - new Date(a.lastSkeleton?.date ?? new Date(0)).getTime()).map(value1 => {
                return {
                    ...value1,
                    reponame: value1.repo.repo,
                }
            }));
            setLoading(false);
        });
        return () => agent.unsubscribe(id);
    }, []);

    return (<>
        <Loading open={loading}></Loading>
        <Container>
            <div className={'content'}>
                <SearchInput data={jobs} setSearchResult={setFilteredJobs} searchableKeys={['reponame']}></SearchInput>
                {filteredJobs.map(job => (
                    <div className={'job-item'} key={job.repo.repo}
                         onClick={() => navigate('/?repo=' + encodeURIComponent(job.repo.withoutBranch))}>
                        <h1>{job.repo.name}</h1>
                        <div style={{position: 'relative'}}>
                            <Status status={job.lastSkeleton?.status ?? 'waiting'}></Status>
                        </div>
                        <div>last
                            build: {(job.lastSkeleton?.date ? new Date(job.lastSkeleton!.date).toLocaleString() : 'N/A')}</div>
                    </div>
                ))}
            </div>
        </Container>
    </>);

}